import { generateClient } from "aws-amplify/api";
import {
  createUserInfo,
  updateUserInfo,
  createStateToUserInfo,
} from "../graphql/mutations";
import {
  getUserBySub,
  getBglToken,
  updateBglToken,
  getClassSuperToken,
  verifyEmail,
} from "../graphql/queries";
import { fetchUserAttributes, signIn } from "@aws-amplify/auth";

const client = generateClient();

const userService = {
  add: async (userData) => {
    const res = await client.graphql({
      query: createUserInfo,
      variables: {
        input: {
          sub: userData.sub,
          email: userData.email,
          given_name: userData.given_name,
          family_name: userData.family_name,
          isActive: true,
          state: userData.state,
          bglToken: "",
          bglIsValid: false,
        },
      },
      authMode: "iam",
    });

    // perform updates to other DynamoDB table here
    await client.graphql({
      query: createStateToUserInfo,
      variables: {
        input: {
          state: res.data?.createUserInfo?.state,
          userId: res.data?.createUserInfo?.id,
        },
      },
      authMode: "iam",
    });
    return res.data?.createUserInfo;
  },
  getUser: async (sub) => {
    const res = await client.graphql({
      query: getUserBySub,
      variables: { sub },
    });
    return res.data?.getUserBySub?.items[0];
  },
  updateUser: async (data) => {
    const userAttributes = await fetchUserAttributes();
    const res = await userService.getUser(userAttributes?.sub);
    let userInfo = {};
    userInfo = JSON.parse(res[data.type]);
    userInfo = {
      ...userInfo,
      ...data.data,
    };
    let variables = {
      input: {
        id: res.id,
        [data.type]: JSON.stringify(userInfo),
      },
    };

    const updateUser = await client.graphql({
      query: updateUserInfo,
      variables,
      authMode: "userPool",
    });
    return updateUser?.data?.updateUserInfo;
  },
  updateUserProfile: async (data) => {
    const userAttributes = await fetchUserAttributes();
    const res = await userService.getUser(userAttributes.sub);
    let userInfo = {
      id: res.id,
      ...data.data,
    };
    let variables = {
      input: userInfo,
    };

    const updateUser = await client.graphql({
      query: updateUserInfo,
      variables,
      authMode: "userPool",
    });
    return updateUser?.data?.updateUserInfo;
  },
  updateUsersKey: async (data) => {
    let variables = {
      input: {
        id: data.data.userId,
        [data.type]: data.data[data.type],
      },
    };

    const updateUser = await client.graphql({
      query: updateUserInfo,
      variables,
      authMode: "userPool",
    });
    return updateUser?.data?.updateUserInfo;
  },
  getUserFlatObject: (res) => {
    const userInfo = {
      id: res.id,
      email: res.email,
      sub: res.sub,
      accountCreationDate: res.createdAt,
      family_name: res.family_name,
      given_name: res.given_name,
      isActive: res.isActive,
      state: res.state,
      bglIsValid: res.bglIsValid,
      bglTokenExpirationDate: res.bglTokenExpirationDate,
      bglRefreshExpirationDate: res.bglRefreshExpirationDate,
      classSuperToken: res.classSuperToken,
      classSuperTokenExpirationDate: res.classSuperTokenExpirationDate,
      classSuperRefreshExpirationDate: res.classSuperRefreshExpirationDate,
      classSuperIsValid: res.classSuperIsValid,
      consentType: res.consentType,
    };
    return userInfo;
  },
  getUserBglToken: async (code, state) => {
    const response = await client.graphql({
      query: getBglToken,
      variables: { code, state },
      authMode: "iam",
    });
    return response.data?.getBglToken || [];
  },

  getUserSuperClassToken: async (code, state) => {
    const response = await client.graphql({
      query: getClassSuperToken,
      variables: { code, state },
      authMode: "iam",
    });
    return response.data?.getClassSuperToken || [];
  },
  getUserBglTokenUP: async (code, state) => {
    const response = await client.graphql({
      query: getBglToken,
      variables: { code, state },
      authMode: "userPool",
    });
    return response.data?.getBglToken || [];
  },
  getUserSuperClassTokenUP: async (code, state) => {
    const response = await client.graphql({
      query: getClassSuperToken,
      variables: { code, state },
      authMode: "userPool",
    });
    return response.data?.getClassSuperToken || [];
  },

  updateUserBglToken: async () => {
    const response = await client.graphql({
      query: updateBglToken,
      variables: {},
      authMode: "userPool",
    });
    return response.data?.updateBglToken || [];
  },
  addDataToUserState: async (userId, state) => {
    await client.graphql({
      query: createStateToUserInfo,
      variables: {
        input: {
          state: state,
          userId: userId,
        },
      },
      authMode: "apiKey",
    });
  },
  userEmailExists: async (email) => {
    return await signIn({ username: email.toLowerCase(), password: "123" })
      .then((res) => {
        console.log(JSON.stringify(res));
        return true;
      })
      .catch((error) => {
        console.log(JSON.stringify(error));
        if (error.name === "UserNotFoundException") {
          // User doesn't exist
          return false;
        }
        // Handle other errors
        throw error;
      });
  },
  sentVerificationEmail: async (email, code, type, otpEmail = "") => {
    const res = await client.graphql({
      query: verifyEmail,
      variables: { email, code, type, otpEmail },
    });
    return res.data?.verifyEmail;
  },
};

export default userService;
